angular.module('CarsSaraBo').controller('ContractController', [
    '$scope', '$rootScope', '$routeParams', '$location', 'ContractService', 'PointOfSaleService', 'DataService', '$q',
    'Upload', 'SessionService', 'CompanyService', 'LoadingWheelService', 'NotificationService', 'ModalService',
    'EmailValidatorService', 'LegalDocumentService', 'LegalDocumentResourceService', '$http', 'ContractStatesService',
    function ($scope, $rootScope, $routeParams, $location, contractService, pointOfSaleService, dataService, $q,
              Upload, sessionService, companyService, loadingWheelService, notificationService, modalService,
              emailValidatorService, legalDocumentService, legalDocumentResourceService, $http, statesService) {

        const MIN_COMMISSION_VALUE = 20;
        const MAX_COMMISSION_VALUE = 35;
        const MAX_FILE_SIZE = 6000000;
        var promiseUploadFile;

        function initialize() {
            loadingWheelService.show();
            $scope.companyValidated = true;
            $scope.originalSegType = "";
            $scope.validations = {};
            $scope.isNew = $routeParams.oid === "new";
            $scope.file = [];
            $scope.contract = {published: false, legalDocuments: []};
            $scope.role =  sessionService.getUserSession().userType;

            $scope.currentLegalDocument = {
                oid:null,
                file:[],
                uploadedBy:null,
                uploadedDate:null,
                fileName:null
            };

            $scope.company = {};
            $scope.visibilities = ["PUBLISHED", "NOT_PUBLISHED"];
            $scope.commissionsAgreements = ["COMMISSIONABLE", "MARKUP"];
            $scope.paymentMethods = [
                {value: "PAYMENT_AT_DESTINATION", checked: false},
                {value: "PREPAYMENT_COMMISSION", checked: false},
                {value: "PREPAYMENT", checked: false}  /* temporarily disabled. Waiting CFA confirmation */
            ];
            $scope.segmentationTypes = [
                {value : "AMBER"},
                {value : "RUBY"},
                {value : "IVORY"},
                {value : "EMERALD"},
                {value : "DIAMOND"}
            ];

            //The following countries should have disabled PREPAYMENT:  ARGENTINA, ECUADOR, PERU
            $scope.prepaymentDisabledFor = [20010, 20057, 20158];

            $scope.period = {};
            $scope.period.from = new Date();
            $scope.period.to = null;
            $scope.posSelected = {};
            $scope.commissionType = null;
            $scope.showMigrationChkbox = null;
            $scope.companyOid = $routeParams.companyOid;
            $scope.editableContract = isEditableContract();
            $scope.showSegmentations = seeSegmentationSection();
            $scope.editableSegmentation = editSegmentationCompany();
            $scope.migrateCompanyPermission = editCommissionableToMarkup();
            $scope.dateBeforeTodayString = getDateBeforeTodayString();

            $scope.$watch('file', function (file) {
                if(file && file.length > 0){
                    $scope.showInputToDragAndDropFile(false);
                    $scope.upload([$scope.file]);
                }
            });

            $scope.obj = {};
            $scope.obj.hasValue = "";
            dataService.categories().$promise.then(function (categories) {
                $scope.categories = categories;
            });
            $scope.currencyCode = sessionService.session.currencyCode;
            $scope.migrationWarning=false;
            $scope.chkMigration = false;

            $scope.inputToDragAndDropFile = true;

            $scope.errorUploadingFile = false;
            $scope.uploadingFile = false;
            $scope.uploadedFile = false;

            $scope.messageUpload = true;

            $scope.disabledInputUploadFile = false;
            loadData();
            loadCompanyData();
        }

        function showMigrationChkbox(commissionType) {
            return sessionService.loggedUserAllowed('PERM_USER_TYPE_DESPEGAR') && commissionType != 'MARKUP' && $scope.isNew == false;

        }

        function editCommissionableToMarkup() {
            return sessionService.loggedUserAllowed('PERM_CONTRACT_MARKUP_MIGRATION');
        }

        function isEditableContract() {
            var canCreate = $scope.isNew && sessionService.loggedUserAllowed('PERM_CONTRACT_CREATE');
            var canEdit = !$scope.isNew && sessionService.loggedUserAllowed('PERM_CONTRACT_EDIT');

            return canCreate || canEdit;
        }

        function seeSegmentationSection(){
            return sessionService.loggedUserAllowed('PERM_USER_TYPE_DESPEGAR');
        }

        function editSegmentationCompany(){
            return sessionService.loggedUserAllowed('PERM_COMPANY_SEGMENT_EDIT');
        }

        $scope.upload = function (files) {

            if (files[0] && files[0].length > 0) {
                promiseUploadFile = Upload.upload({
                    url: '../rest/company/' + $scope.companyOid + '/contract/' + $scope.contract.oid + '/legalDocument',
                    file: files[0],
                    data: sessionService.getUserLogged().username

                }).progress(function (evt) {
                    $scope.showUploadingFile(true);
                    loadingWheelService.show();

                }).success(function (data, status, headers, config) {
                    loadingWheelService.hide();
                    $scope.disableInputUploadFile(true);
                    $scope.showUploadingFile(false);
                    $scope.showUploadedFile(true);

                    $scope.currentLegalDocument = {
                        oid:data.oid,
                        file:files[0],
                        uploadedBy:data.uploadedBy,
                        uploadedDate:data.uploadedDate,
                        fileName:data.fileName,
                        state: data.state
                    };
                }).error(function (data, status, headers, config) {
                    notificationService.toastVisible = false;
                    loadingWheelService.hide();
                    $scope.showUploadingFile(false);
                    $scope.showErrorUploadingFile(true);
                    $scope.currentLegalDocument = {
                        file:files[0]
                    };
                });
            }
        };

        $scope.changeCategoriesRanges = function (rateBoundedByCategory) {
            if (rateBoundedByCategory === true) {
                if ($scope.contract.defaultRateAmountBound) {
                    $scope.contract.defaultRateAmountBound.min = null;
                    $scope.contract.defaultRateAmountBound.max = null;
                }
                $scope.contract.rateAmountBounds = {};
            }
            if (rateBoundedByCategory === false) {
                $scope.contract.rateAmountBounds = null;
            }
        };

        function loadData() {

            //List of other contracts for the current company
            contractService.query({companyOid: $routeParams.companyOid}, function (response) {
                $scope.otherContracts = response;
                $scope.getAlreadyUsedBranches();
            });

            $scope.pointsOfSale = [];

            pointOfSaleService.resource.query({companyOid: $routeParams.companyOid}, function (pointsOfSale) {
                $scope.pointsOfSale = pointsOfSale;
                $scope.validations.pointsOfSale = true;

                if ($scope.isNew) {
                    loadingWheelService.hide();
                    return;
                }

                //getting the contract by ID, for the current company
                contractService.get({companyOid: $routeParams.companyOid, oid: $routeParams.oid}, function (response) {
                    loadingWheelService.hide();
                    $scope.contract = response;
                    checkPaymentMethods($scope.contract);
                    angular.forEach(response.pointsOfSale, function (item) {
                        $scope.posSelected[item] = {"checked": true};
                    });
                    $scope.showMigrationChkbox = showMigrationChkbox($scope.contract.commissionType);
                    var from = response.period.from;
                    var to = response.period.to;
                    $scope.period.from = new Date(from.substring(0, 4), (parseInt(from.substring(5, 7)) - 1).toString(), from.substring(8, 10));
                    $scope.period.to = new Date(to.substring(0, 4), (parseInt(to.substring(5, 7)) - 1).toString(), to.substring(8, 10));

                    //Getting the legals documents for the current contract
                    loadDocumentsByContract();
                });
                loadingWheelService.hide();
            });
        }

        function loadDocumentsByContract() {
            legalDocumentService.query({companyOid: $routeParams.companyOid, contractOid: $routeParams.oid}, function (response) {
                $scope.contract.legalDocuments = response;

                //searching for 'pending' document
                angular.forEach($scope.contract.legalDocuments, function (legalDocument) {
                    if(statesService.isPENDING(legalDocument.state) || statesService.isDISPUTED(legalDocument.state)){
                        $scope.disabledInputUploadFile = true;
                    }
                });
            })
        }

        function loadCompanyData() {
            companyService.get({oid: $routeParams.companyOid}, function (company) {
                $scope.companyValidated = company.validated;
                $scope.company = company;
                $scope.segmentationTypes.forEach((segment)=>{ segment.checked = segment.value === $scope.company.segmentationType; });
            });
        }

        function checkPaymentMethods(contract) {
            for (var i in $scope.paymentMethods) {
                var pm = $scope.paymentMethods[i];
                pm.checked = contract.paymentMethods.includes(pm.value);
            }
        }

        function isValid() {
            var isValid = true;
            var errorList = [];
            var today = new Date();
            today.setHours(0, 0, 0, 0);

            if (!($scope.period.from instanceof Date) || !($scope.period.to instanceof Date)) {
                isValid = false;
                $scope.errorField['rangeDate'] = "input-error";
            }

            if ($scope.period.from > $scope.period.to) {
                isValid = false;
                $scope.errorField['maxDate'] = "input-error";
                errorList.push({code: "contract.ERROR_FROM_TO_DATE"});
            }

            if ($scope.contract.rateBoundedByCategory) {
                angular.forEach($scope.categories, function (categoryCode) {
                    var category = $scope.contract.rateAmountBounds[categoryCode.code];
                    if (!category || !category.min || category.min == 0 || !category.max || category.max == 0) {
                        isValid = false;
                        $scope.errorField[categoryCode.code + '.min'] = "input-error";
                        $scope.errorField[categoryCode.code + '.max'] = "input-error";
                        errorList.push({code: "contract.ALL_CATEGORIES_ARE_REQUIRED"});
                    }
                    else if (category.max < category.min) {
                        isValid = false;
                        $scope.errorField[categoryCode.code + '.min'] = "input-error";
                        $scope.errorField[categoryCode.code + '.max'] = "input-error";
                        errorList.push({code: "contract.MAX_LESS_THAN_MIN"});
                    }
                });
            }

            if (!$scope.isNew) {
                var to = new Date($scope.contract.period.to);
                to.setHours(0, 0, 0, 0);
                if ($scope.period.to < to) {
                    isValid = false;
                    $scope.errorField['maxDate'] = "input-error";
                    errorList.push({code: "contract.ERROR_MODIFICATION_DATE"});
                }
            } else {
               if ($scope.period.from < today || $scope.period.to < today) {
                    isValid = false;
                    $scope.errorField['rangeDate'] = "input-error";
                    errorList.push({code: "contract.ERROR_BEFORE_TODAY_DATE"});
                }
            }

            if (!$scope.contract.rateBoundedByCategory && (
                !$scope.contract.defaultRateAmountBound
                || !$scope.contract.defaultRateAmountBound.max
                || !$scope.validAmountFieldTwoDecimals($scope.contract.defaultRateAmountBound.min)
                || !$scope.contract.defaultRateAmountBound.min
                || !$scope.validAmountFieldTwoDecimals($scope.contract.defaultRateAmountBound.max))) {
                isValid = false;
                $scope.errorField['contractMinimumRate'] = "measure-error";
                $scope.errorField['contractMaximumRate'] = "measure-error";
                errorList.push({code: "warning.invalidNumberFormat"});
            }
            else if ($scope.contract.defaultRateAmountBound && ($scope.contract.defaultRateAmountBound.max < $scope.contract.defaultRateAmountBound.min)) {
                isValid = false;
                $scope.errorField['contractMinimumRate'] = "measure-error";
                $scope.errorField['contractMaximumRate'] = "measure-error";
                errorList.push({code: "contract.MAX_LESS_THAN_MIN"});
            }

            if (getSelectedPaymentMethods().length < 1) {
                isValid = false;
                $scope.errorField['paymentMethods'] = "required";
            }

            if ( $scope.contract.commissionType != 'MARKUP' &&($scope.contract.commission < MIN_COMMISSION_VALUE || $scope.contract.commission > MAX_COMMISSION_VALUE)) {
                isValid = false;
                $scope.errorField['contractCommission'] = "input-error";
                errorList.push({code: "contract.invalidCommission"});
            }

            if (!$scope.contract.businessExecutiveContact) {
                $scope.errorField['businessExecutiveContact'] = "required";
                isValid = false;
            }

            if (!emailValidatorService.validate($scope.contract.businessExecutiveContact)) {
                $scope.errorField['businessExecutiveContact'] = "input-error";
                errorList.push({code: "contract.INCORRECT_EMAIL"});
                isValid = false;
            }

            if ($scope.chkMigration && $scope.period.to < today){
                $scope.errorField['migrationWithExpiredDate'] = "input-error";
                errorList.push({code: "contract.endDate.expired"});
                isValid = false;
            }

            if ($scope.chkMigration && $scope.contract.published){
                $scope.errorField['migrationWithPublishedContract'] = "input-error";
                errorList.push({code: "contract.company.published"});
                isValid = false;
            }

            if (errorList.length > 0) {
                for (var i in errorList) {
                    notificationService.notifyErrorByCodeWithParams(errorList[i].code, errorList[i].params);
                }
            }

            return isValid;
        }

        $scope.closeMigrationModal = function(){
            $scope.migrationWarning = false;
        }

        $scope.showMigrationWarning = function(){
            if($scope.chkMigration) {
                $scope.migrationWarning = true;
            }
            else{
                $scope.save();
            }
        }

        $scope.checkedMigration = function(){
            $scope.chkMigration = !$scope.chkMigration;
        }

        $scope.updateValidation = function (field) {
            if ($scope.errorField != undefined && $scope.errorField[field]) {
                $scope.errorField[field] = null;
            }
            $scope.getAlreadyUsedBranches();
        };

        $scope.isPaymentMethodDisabled = function (paymentMethod) {
            if (paymentMethod.value == 'PAYMENT_AT_DESTINATION' && $scope.contract.commissionType == 'MARKUP') {
                paymentMethod.checked = false;
                return true;
            }

            //Mega parche para que una Rentadora de ARGENTINA, PERU, CHILE O ECUADOR no pueda seleccionar "Prepago
            if (paymentMethod.value == 'PREPAYMENT' &&  $scope.prepaymentDisabledFor.includes($scope.company.countryOid)) {
                paymentMethod.checked = false;
                return true;
            }
            return false;
        };

        $scope.save = function () {
            $scope.migrationWarning = false;
            var deferred = $q.defer();
            $scope.errorField = {};

            if (isValid() && $scope.contractForm.$valid) {
                fillContract($scope.posSelected);
                $scope.contract.published = undefined;
                saveOrUpdate(deferred);
            } else {
                deferred.reject();
                for (var i in $scope.contractForm.$error.required) {
                    $scope.errorField[$scope.contractForm.$error.required[i].$name] = "input-error";
                }
                for (var i in $scope.contractForm.$error.number) {
                    $scope.errorField[$scope.contractForm.$error.number[i].$name] = "input-error";
                }
            }
            notificationService.notifyFormErrors($scope.contractForm.$error);
            return deferred.promise;
        };

        function saveOrUpdate(deferred) {
            loadingWheelService.show();
            function successCallBack() {
                deferred.resolve();
                goBack();
                notificationService.notifySuccessByCode('contract.confirmationMessage.SUCCESS_SAVE');
            }

            function errorCallBack() {
                deferred.reject();
            }

            if(updatedSegmentation()){
                $scope.company.segmentationType = getSelectedSegmentationType();
                companyService.update({oid: $routeParams.companyOid}, $scope.company);
            }

            $scope.contract.migrateToMarkup = $scope.chkMigration;

            if($scope.contract.oid == null) {
                contractService.save({companyOid: $routeParams.companyOid}, $scope.contract)
                    .$promise
                    .then(function(response){
                        successCallBack();
                    }, function(error){
                        errorCallBack()
                    });
            } else {
                contractService.update({companyOid: $routeParams.companyOid}, $scope.contract)
                    .$promise
                    .then(function(response){
                        loadingWheelService.hide();
                        successCallBack()},
                    function(error){
                        errorCallBack()});
            }
        }

        function updatedSegmentation() {
            var segSelected = $scope.segmentationTypes.filter(seg => seg.checked === true);
            return $scope.originalSegType != segSelected[0].value;
        }

        function fillContract(pos) {
            $scope.contract.pointsOfSale = [];
            $scope.contract.period = {};
            $scope.contract.period.from = formatToyyyyMMdd($scope.period.from);
            $scope.contract.period.to = formatToyyyyMMdd($scope.period.to);
            for (var i in pos) {
                if (pos[i].checked == true) {
                    $scope.contract.pointsOfSale.push(i);
                }
            }
            $scope.contract.paymentMethods = getSelectedPaymentMethods();
        }

        function getSelectedSegmentationType() {
            var segName =  $scope.segmentationTypes.filter(segment => segment.checked === true);
            return segName[0].value;
        }

        function getSelectedPaymentMethods() {
            var selectedPaymentMethods = [];
            for (var i in $scope.paymentMethods) {
                var pm = $scope.paymentMethods[i];
                if (pm.checked) {
                    selectedPaymentMethods.push(pm.value);
                }
            }
            return selectedPaymentMethods;
        }

        $scope.handleSegmentationChange= function(segmentChecked){
            $scope.segmentationTypes.forEach((segment)=>{ segment.checked = segment.value === segmentChecked; });
        };

        $scope.getNoSingleValueDate = function (dateFunction) {
            return (dateFunction > 9) ? dateFunction.toString() : '0' + dateFunction.toString();
        };

        function formatToyyyyMMdd(date) {
            return date.getFullYear().toString() + $scope.getNoSingleValueDate(date.getMonth() + 1) + $scope.getNoSingleValueDate(date.getDate());
        }

        function goBack() {
            $location.path("/company/" + $routeParams.companyOid + "/contract/");
        }

        $scope.cancel = function () {

            modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
                if($scope.currentLegalDocument.oid){
                    $scope.deleteTermCreated();
                }
                goBack();
            });
        };

        $scope.checkAll = function () {
            var select = this.selectedAll;
            angular.forEach($scope.pointsOfSale, function (item) {
                if ($scope.alreadyUsedBranches.indexOf(item.oid) == -1) {
                    $scope.posSelected[item.oid] = {"checked": select};
                }
            });
        };

        $scope.verifyAllPos = function () {
            $scope.selectedAll = $scope.allSelected($scope.posSelected);
        }

        $scope.getAlreadyUsedBranches = function () {

            var branches = [];

            if ($scope.period.from != null && $scope.period.to != null) {

                $scope.otherContracts.forEach(function (otherContract) {
                    if ($scope.contract.oid != otherContract.oid &&
                        $scope.dateRangeOverlaps($scope.period.from, $scope.period.to, otherContract.period.from, otherContract.period.to)) {
                        otherContract.pointsOfSale.forEach(function (pointOfSaleOid) {
                            if (branches.indexOf(pointOfSaleOid) == -1) {
                                branches.push(pointOfSaleOid);
                                delete $scope.posSelected[pointOfSaleOid];
                            }
                        });
                    }
                });
            }
            $scope.alreadyUsedBranches = branches;
        }

        $scope.dateRangeOverlaps = function (a_start, a_end, b_start, b_end) {
            return (a_start.getTime() <= new Date(b_end).getTime()) && (a_end.getTime() >= new Date(b_start).getTime());
        }

        function getDateBeforeTodayString () {
            var today = new Date();
            return "'" + (today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + (today.getDate())) + "'";
        }

        $scope.showUploadedFile = function(val){
            $scope.uploadedFile = val;
        }

        $scope.showErrorUploadingFile = function(val){
            $scope.errorUploadingFile = val;
        }

        $scope.showUploadingFile = function(val){
            $scope.uploadingFile = val;
        }

        $scope.showMessageUpload = function(val){
            $scope.messageUpload = val;
        }

        $scope.showInputToDragAndDropFile = function(val){
            $scope.inputToDragAndDropFile = val;
        }

        $scope.retryUploadFile = function(){
            $scope.file = null;
            if($scope.currentLegalDocument.file){
                $scope.showErrorUploadingFile(false);
                $scope.showInputToDragAndDropFile(false);
                $scope.upload([$scope.currentLegalDocument.file]);
            }else{
                $scope.closeMessageError();
            }
        }

        $scope.closeMessageError = function(){
            $scope.showErrorUploadingFile(false);
            $scope.showInputToDragAndDropFile(true);
            $scope.file = null;
            $scope.legalDocuments = null;
        }

        $scope.disableInputUploadFile = function(value){
            $scope.disabledInputUploadFile = value;
        }

        $scope.deleteUploadedFile = function(){
            $scope.showUploadedFile(false);
            $scope.showInputToDragAndDropFile(true);
            $scope.showMessageUpload(true);
            $scope.disableInputUploadFile(false);

            //deleting term file in state CREATED
            $scope.deleteTermCreated();

            //Getting the legals documents for the current contract
            loadDocumentsByContract();
        }

        $scope.deleteTermCreated = function(){
            var deferred = $q.defer();
            loadingWheelService.show();
            legalDocumentService.remove({companyOid: $routeParams.companyOid, contractOid: $scope.contract.oid, legalDocumentOid: $scope.currentLegalDocument.oid})
                .$promise
                .then(function(response){
                    loadingWheelService.hide();
                    deferred.resolve();
                }, function(error){
                    loadingWheelService.hide();
                    deferred.reject();
                }
            );
            $scope.file = null;
            $scope.currentLegalDocument = null;
        }

        $scope.getColorByState = function(term){
            return statesService.getColorByState(term);
        }

        $scope.goToDetailDocument = function(legalDocumentOid){
            $location.path("/company/" +  $routeParams.companyOid + "/contract/" + $scope.contract.oid + "/viewTerm/" + legalDocumentOid);
        }

        $scope.getDocumentLink = function (legalDocumentOid) {

            $http({
                method: 'GET',
                url: "/cars-sara-v2/rest/company/" + $routeParams["companyOid"] + "/contract/" + $routeParams["oid"] + "/legalDocument/" + legalDocumentOid + "/resource",
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                headers = headers();
                var filename = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                    notificationService.showToast('common.ERROR_500', null, null,'ERROR',10000);
                }
            }).error(function (data) {
                console.log(data);
                notificationService.showToast('common.ERROR_500', null, null,'ERROR',10000);
            });
        }

        $scope.formatDate = function(date){
            var newDate = new Date(Date.parse(date));
            var dateFormated = $scope.getNoSingleValueDate(newDate.getDate()) + '/' +
                $scope.getNoSingleValueDate(newDate.getMonth() + 1) + '/' +
                newDate.getFullYear().toString() + ' - ' +
                $scope.getNoSingleValueDate(newDate.getHours()) + ':' +
                $scope.getNoSingleValueDate(newDate.getMinutes());

            return  dateFormated;
        }

        $scope.userCanUploadFile = function(){
            return isUserRolDespegar() && isPermLegalDocumentUpload() && !$scope.isNewContract($scope.contract.oid);
        }

        $scope.isNewContract = function(contractOid){
            return !contractOid;
        }

        $scope.isUserAllowedAcceptClaimTerm = function(term){
            return isPermLegalDocumentEdit() && isUserRolCompany() && (statesService.isPENDING(term.state) || statesService.isDISPUTED(term.state));
        }

        $scope.isUserAllowedViewTerm = function(term){
            return isPermLegalDocumentEdit() && isUserRolCompany() && (!statesService.isPENDING(term.state) && !statesService.isDISPUTED(term.state));
        }

        $scope.isUserAllowedCancelTerm = function(term){
            return isPermLegalDocumentUpload() && isUserRolDespegar() && (statesService.isPENDING(term.state) || statesService.isDISPUTED(term.state));
        }

        $scope.showEmptyStateDocuments = function(){
            return !$scope.contract.legalDocuments || $scope.contract.legalDocuments.length === 0;
        }

        $scope.cancelUploadingFile = function(){
            //promiseUploadFile.abort(); //TODO don't work
            loadingWheelService.hide();
            $scope.showUploadingFile(false);
            $scope.showInputToDragAndDropFile(true);
            $scope.file = null;
            $scope.currentLegalDocument = null;
        }

        $scope.isNewTerm = function(term){
            return (statesService.isPENDING(term.state) || statesService.isDISPUTED(term.state));
        }

        $scope.isActiveTerm = function(term){
            return term.active;
        }
        $scope.invalidateDocument = function(term){
            updateLegalDocumentState(statesService.INVALIDATED(),term);
        }

        function isUserRolDespegar(){
            return $scope.role === 'DESPEGAR';
        }

        function isUserRolCompany(){
            return $scope.role === 'COMPANY';
        }

        $scope.isTACITLYACCEPTED = function(state){
            return statesService.isTACITLYACCEPTED(state);
        }

        $scope.isCREATED = function(state){
            return statesService.isCREATED(state);
        }

        function isPermLegalDocumentUpload(){
            return sessionService.loggedUserAllowed('PERM_LEGAL_DOCUMENT_UPLOAD');
        }

        function isPermLegalDocumentEdit(){
            return sessionService.loggedUserAllowed('PERM_LEGAL_DOCUMENT_EDIT');
        }

        function updateLegalDocumentState(state, term){
            loadingWheelService.show();
            var deferred = $q.defer();
            legalDocumentService.update({companyOid: $routeParams.companyOid, contractOid:$routeParams["oid"], legalDocumentOid:term.oid}, {modifiedBy:sessionService.getUserLogged().username, state: state})
                .$promise.then(
                function(response){
                    deferred.resolve();
                    loadDocumentsByContract();
                    $scope.showInputToDragAndDropFile(true);
                    $scope.disableInputUploadFile(false);
                    notificationService.notifySuccessByCode('contract.terms.toast.title.cancel_ok', 'contract.terms.toast.message.cancel_ok',10000);
                    loadingWheelService.hide();},
                function(error){
                    deferred.reject();
                    loadingWheelService.hide();
                });
        }

        $scope.isScrollEnabled = function(state){
            return $scope.contract.legalDocuments && $scope.contract.legalDocuments.length > 5;
        }

        initialize();
    }]);



//////////////////
// WEBPACK FOOTER
// ./public/app/contract/contract_controller.js
// module id = 918
// module chunks = 3